var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.layout,{tag:"component",scopedSlots:_vm._u([{key:"nav",fn:function(){return [_c('AdminNav')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }